export const createPressHandlers = (handler: () => void) => ({
  onMouseDown: (e: MouseEvent) => {
    e.preventDefault();
    handler();
  },
  onTouchStart: (e: TouchEvent) => {
    e.preventDefault();
    handler();
  },
});
